import React from 'react';
import {
    Box
} from '@mui/material';
import ExpandedDropDown from '../../dropdown/ExpandedDropDown';

function UploadIllusionEDLDropdowns(props) {
    const {
        onPullTypeChange = () => {},
        onVendorChange = () => {},
        pullType = {},
        pullTypes = [],
        vendor = {},
        vendors = [],
    } = props;
    return (
        <Box
            sx={{
                display: 'flex',
                gap: '1rem'
            }}
        >
            {pullTypes.length > 0 && (
                <Box
                    sx={{
                        flex: pullTypes.length > 0 ? 1 : 0
                    }}
                >
                    <ExpandedDropDown
                        label='Pull Type'
                        value={pullType?.value || ''}
                        onChange={onPullTypeChange}
                        options={pullTypes}
                        fullWidth
                    />
                </Box>
            )}
            {vendors.length > 0 && (
                <Box
                    sx={{
                        flex: vendors.length > 0 ? 1 : 0
                    }}
                >
                    <ExpandedDropDown
                        label='Vendor'
                        value={vendor?.value || ''}
                        onChange={onVendorChange}
                        options={vendors}
                        fullWidth
                    />
                </Box>
            )}
        </Box>
    );
}

export default UploadIllusionEDLDropdowns;
